exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-fb285176] .el-switch__label--left{background:transparent!important}.label[data-v-fb285176]{display:inline-block;font-size:14px;text-align:right;padding-right:12px;box-sizing:border-box;vertical-align:top}.label[data-v-fb285176] .el-icon--right{margin-left:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fb285176","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Switch/index.vue
// module id = 612
// module chunks = 0